// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailHeader";

headerStyles.buttonGridItem = {
    ...headerStyles.buttonGridItem,
    width: [2, 2, 1, 6, 6],
};

headerStyles.titleGridItem = {
    width: [10, 10, 11, 6, 6],
};
